import styled from "styled-components";
import React from "react";
import { useIntl } from "react-intl";

const BASE_DOT_SIZE = 18;
const BASE_DOT_MARGIN = 10;

const Container = styled.div`
  overflow: visible;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 250px;
  @keyframes loadingPulse {
    0% {
      transform: scale(1);
    }
    10% {
      transform: scale(1.5);
    }
    20% {
      transform: scale(2);
    }
    30% {
      transform: scale(1.5);
    }
    40% {
      transform: scale(1);
    }
  }
  & div:first-child {
    animation: loadingPulse 1.5s infinite linear;
  }
  & div:nth-child(2) {
    animation: loadingPulse 1.5s 0.15s infinite linear;
  }
  & div:nth-child(3) {
    animation: loadingPulse 1.5s 0.3s infinite linear;
  }
  & div:nth-child(4) {
    animation: loadingPulse 1.5s 0.45s infinite linear;
  }
  & div:last-child {
    animation: loadingPulse 1.5s 0.6s infinite linear;
  }
`;

const Dot = styled.div<{ size: number; bgColor: number }>`
  height: ${props => `${props.size}px`};
  width: ${props => `${props.size}px`};
  border-radius: 100%;
  margin: 0 ${props => `${props.size * (BASE_DOT_MARGIN / BASE_DOT_SIZE)}px`};
  background: ${props =>
    props.theme.vstui.color.primary.getShade(props.bgColor)};
`;

const DotLoader = ({ size }: { size: number }) => {
  const intl = useIntl();
  const dotColors = [2, 3, 4, 6, 7];

  return (
    <Container aria-label={intl.formatMessage({ id: "general.loading" })}>
      {dotColors.map(c => (
        <Dot key={`dot ${c}`} bgColor={c} size={size} />
      ))}
    </Container>
  );
};

export const SmallLoader = () => <DotLoader size={9} />;
export const LargeLoader = () => <DotLoader size={18} />;
